"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const contactData = [{
  label: "Betreiberin",
  value: "Claudia Christ\nDiplom-Psychologin\nHeilpraktikerin für Psychotherapie"
}, {
  label: "Kontakt",
  value: "post@claudiachrist.de\n+49 6706 9151738"
}, {
  label: "Adresse",
  value: "Im Rödchen 3\n55595 Spabrücken"
}, {
  label: "Aufsichtsbehörde",
  value: "Gesundheitsamt Bad Kreuznach\nRingstraße 4\n55543 Bad Kreuznach"
}, {
  label: "Berufsrecht",
  value: "Gesetzliche Berufsbezeichnung: Diplom-Psychologin / Heilpraktikerin für Psychotherapie (verliehen in der Bundesrepublik Deutschland / Hessen).\nRegelungen: Heilpraktikergesetz und Durchführungsverordnung."
}, {
  label: "Versicherung",
  value: "Risikoträger: NÜRNBERGER Versicherung Aktiengesellschaft, Ostendstraße 100, 90482 Nürnberg\nVermittelt durch: Triplex Gesellschaft für Finanzanalyse, Anlage- und Immobilienvermittlung GmbH, 88069 Tettnang\nGeltungsbereich: Bundesrepublik Deutschland"
}, {
  label: "Umsatzsteuer-ID",
  value: "DE288946560"
}, {
  label: "Verantwortlich nach § 18 MStV",
  value: "Claudia Christ\nIm Rödchen 3\n55595 Spabrücken"
}];
export default function OperatorAndContactData() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="betreiber-und-kontaktdaten" className="bg-background py-24">
      <div ref={ref} className={`container mx-auto px-4 md:px-6 max-w-4xl transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[20px]"}`}>
        <div className="flex flex-col gap-12 md:gap-16">
          {contactData.map((item, i) => <div key={i} data-index={i} className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 border-b border-border/40 pb-12 last:border-0 last:pb-0">
              <div className="md:col-span-4">
                <h3 className="font-default font-bold text-[14px] tracking-widest uppercase text-primary">
                  {item.label}
                </h3>
              </div>
              <div className="md:col-span-8">
                <p className="font-default font-light text-[18px] leading-[1.7] text-foreground whitespace-pre-line">
                  {item.value}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}